import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  // 강의 레슨 목록 조회
  async index(lectureId: number, params?: any) {
    return camelize(await $axios.get(`/lecture/${lectureId}/lessons`, snakelize({ params })))
  },
})
